import React from 'react';
import { themeCompany as theme } from './data/themes';

const ThemeContext = React.createContext(theme);

export default ThemeContext;
